import { render } from "./notice-pattern-detail.vue?vue&type=template&id=3a0fb6ec"
import script from "./notice-pattern-detail.vue?vue&type=script&lang=js"
export * from "./notice-pattern-detail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__